module.exports = __webpack_public_path__ + "static/sailors-bane-c5f80b6ec0e3271d03847dfe052cd4ea.jpg";